import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../../reducers/types";
import { HotelBookPassengerSelection } from "./component";
import { getHotelShopChosenProduct } from "../../../../hotel-shop/reducer";
import { CorpRoomProduct } from "redmond";

const mapStateToProps = (state: IStoreState) => {
  return {
    chosenProduct: getHotelShopChosenProduct(state) as CorpRoomProduct,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type HotelBookPassengerSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedHotelBookPassengerSelection = connector(
  HotelBookPassengerSelection
);
